module.exports = __webpack_public_path__ + "fonts/barlow-v5-latin-regular.d216a0a.woff2";